// Type definitions for notifications
export interface BubbleNotification {
  _id: string;
  userid_text: string;
  message_text: string;
  message_marked_read_boolean: boolean;
  'Created Date': number;
  'Modified Date': number;
  'Created By': string;
}

export interface Notification {
  id: string;
  userId: string;
  message: string;
  isRead: boolean;
  createdAt: Date;
  modifiedAt: Date;
  createdBy: string;
}

// Helper to transform Bubble API response to app format
export const transformNotification = (bubbleNotif: BubbleNotification): Notification => ({
  id: bubbleNotif._id,
  userId: bubbleNotif.userid_text,
  message: bubbleNotif.message_text,
  isRead: bubbleNotif.message_marked_read_boolean,
  createdAt: new Date(bubbleNotif['Created Date']),
  modifiedAt: new Date(bubbleNotif['Modified Date']),
  createdBy: bubbleNotif['Created By']
});
